type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
  backgroundColor?: string;
};

const PlusIconWithRoundBg = ({
  width = '24',
  height = '24',
  viewBox = '0 0 24 24',
  strokeColor = '#17C964',
  backgroundColor = 'var(--background)',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="12" fill={backgroundColor} />
    <path
      d="M18 12C18 12.1326 17.9473 12.2598 17.8536 12.3536C17.7598 12.4473 17.6326 12.5 17.5 12.5H12.5V17.5C12.5 17.6326 12.4473 17.7598 12.3536 17.8536C12.2598 17.9473 12.1326 18 12 18C11.8674 18 11.7402 17.9473 11.6464 17.8536C11.5527 17.7598 11.5 17.6326 11.5 17.5V12.5H6.5C6.36739 12.5 6.24021 12.4473 6.14645 12.3536C6.05268 12.2598 6 12.1326 6 12C6 11.8674 6.05268 11.7402 6.14645 11.6464C6.24021 11.5527 6.36739 11.5 6.5 11.5H11.5V6.5C11.5 6.36739 11.5527 6.24021 11.6464 6.14645C11.7402 6.05268 11.8674 6 12 6C12.1326 6 12.2598 6.05268 12.3536 6.14645C12.4473 6.24021 12.5 6.36739 12.5 6.5V11.5H17.5C17.6326 11.5 17.7598 11.5527 17.8536 11.6464C17.9473 11.7402 18 11.8674 18 12Z"
      fill={strokeColor}
    />
  </svg>
);

export default PlusIconWithRoundBg;
